import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GridApi, ColDef, GridReadyEvent } from 'ag-grid-community';
import { DataTable } from 'simple-datatables';
import { AlertService } from 'src/app/_services/alert.service';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { MenusService } from 'src/app/_services/menu.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import Swal from 'sweetalert2';
import { MerchantService } from '../../../reseller-setup/merchant.service';
import { CustomerService } from '../../customer-service';

@Component({
  selector: 'app-topup-action',
  templateUrl: './topup-action.component.html',
  styleUrls: ['./topup-action.component.scss']
})
export class TopupActionComponent implements OnInit {

@Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  merchantstatusform: FormGroup;
  isForm1Submitted: boolean;
  @Input() merchantStatusConfig: any;
  @Input() onMerchantMId: EventEmitter<any> = new EventEmitter<any>();
  data: any;
  Resdata: any;
  customerId: any
  walletStatus : any;
  registeredMobile : any
  loading: boolean =false;
  remarkData: any=[]; 
  dataTable: DataTable;
  segmentData: any;
  auditData : any[];
  private gridApi!: GridApi;
  showLimitedStatus: boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    { field: 'walletStatus', headerName: 'Status',lockVisible:true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'remark',  headerName: 'Remark',lockVisible:true, },
    { field: 'updatedBy',  headerName: 'Updated By', lockVisible:true,},
    { field: 'updatedOn',  headerName: 'Updated On' ,lockVisible:true,},
    { colId: 'unmasking', field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
      {
        clicked: async (event: any, param: any) => {
          this.piiGridService.unmaskRow(param.data, this.gridApi);
        },
        buttonIconClass: 'icon-frame-1',
        buttonText: '',
        buttonVisible: true,
        customImage: 'assets/images/unmask-icon.png'
      }
    ] },
  ]

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  constructor(private services: ApiHttpService, private alertService: AlertService, private formbuilder: FormBuilder,private storage:StorageService,private merchantService: MerchantService,private customerService : CustomerService,private router : Router,
    private readonly menuService: MenusService, private readonly piiGridService: PiiGridService) {

    this.data = this.merchantStatusConfig
    this.merchantstatusform = formbuilder.group({
      Status: ["",[ Validators.required]],
      // Segment: ["",[ Validators.required]],
      Remark: ["", [Validators.required,moreThanOneWhiteSpaceValidator(),Validators.maxLength(200)]],
    })
    // if (this.merchantstatusform) {
    //   this.merchantstatusform.get('Segment')?.valueChanges.subscribe(value => {
    //     console.log('Selected Segment:', value); // Log selected value to console
    //   });
    // }
    
  }

  get form1() {
    return this.merchantstatusform.controls;
  }

  ngOnInit(): void {
    console.log("Blocked Component");
    this.auditData = [];

    // permission visibility for unmasking column similar to customer-master
    try {
      const path = '';
      const permissions = this.menuService.getPermissions(path);
      const unmaskCol = this.columnDefs.find(c => c['colId'] === 'unmasking');
      if (unmaskCol) unmaskCol.hide = !(permissions && permissions !== '');
      this.columnDefsCopy = [...(this.columnDefs.filter((col) => !col?.hide))];
      this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];
    } catch (err) {
      console.error('Error applying permissions for blocked modal unmask column', err);
    }

    this.onMerchantMId.subscribe((res) => (
      console.log(JSON.stringify(res)),
      this.walletStatus = res.walletStatus,
      this.customerId = res.mobile,
      this.merchantstatusform.get('Status')?.reset(),
      this.loading = false,
      this.isForm1Submitted = false
      ))
 
  }

  onGridReady(params: GridReadyEvent<any>) {
    console.log("AG Grid")
    this.gridApi = params.api;
  }


  CustomerWalletStatusChange(formvalue : any){
   console.log("Customer Id :"+this.customerId);
   console.log("Status :"+formvalue.Status);
   console.log("Comment :"+formvalue.Remark);
   if(this.walletStatus == formvalue.Status){
    let tempStatus = this.walletStatus || TitleCasePipe
    this.alertService.errorAlertWithMessage("Status is already "+tempStatus);
    return;
   }
   if (this.merchantstatusform.valid) {
      console.log("Valid");
      let walletStatusChangeRequest = {
          "userId" : this.customerId,
          "status" : formvalue.Status, 
          "remark" : formvalue.Remark
        }
      this.customerService.updateTopupStatus(walletStatusChangeRequest)
        .subscribe((data:any) => {
          console.log("Response"+JSON.stringify(data.response.message));
          if(data.response.status == 200){
            this.closeModal.emit({
              showModal: false
            })
            Swal.fire('Customer wallet status updated successfully','','success')
            this.router.navigate(['/customerTransactionReport']);
            return;
          }else{
            this.closeModal.emit({
              showModal: false
            })
            Swal.fire(data.response.message,'','error')
            this.router.navigate(['/customerTransactionReport']);
            return;
          }
        })
        // Swal.fire('Error while changing the wallet status','','error')
    }else{
      this.alertService.errorAlertWithMessage("Mandatory Fields are missing");
        console.log("Not Valid"); 
    } 

  }

}
